// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main___Gvau","tabs":"index_tabs__8PBfl"};